import { Tab, Tabs } from '@mui/material'
import React from 'react'

const LoginTabs = ({tab,handleTabChange}) => {
    return (
        <div>
            <Tabs
                value={tab}
                onChange={handleTabChange}
                centered
                textColor="primary"
                indicatorColor="primary"
                sx={{ mb: 2 }}
            >
                <Tab label="Login with Password" />
                <Tab label="Login with OTP" />
            </Tabs>
        </div>
    )
}

export default LoginTabs